import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-type-integer",
  "use": "icon-type-integer-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-type-integer\"><path d=\"M13 7V6h-1.804L12 3h-1.035l-.804 3H7.196L8 3H6.965l-.804 3H4v1h1.893l-.536 2H3v1h2.089l-.804 3H5.32l.804-3h2.965l-.804 3H9.32l.804-3H12V9h-1.607l.535-2zM9.357 9H6.393l.535-2h2.965z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol